import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import ReportGateway from '~apis/report';
import UtilFunctions from '~utils/functions';
import { FundTypeEnum, MetalTypeEnum } from '~utils/enums';

export default function* watchGetInventoryBranchReportExport(api: ReportGateway): SagaWatcherReturnType {
    yield takeEvery('report/reportGetInventoryBranchReportExportAttempt', handleGetInventoryBranchReportExport, api);
}

function* handleGetInventoryBranchReportExport(api: ReportGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        filters: {
            branchName,
            productId,
            metalType,
            fundType,
            serialNo
        }
    } = reduxState.report.inventoryReport.inventoryBranchReportListing;

    const allBranches = reduxState.branch.allBranches;
    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    const response = yield* call([api, api.getInventoryBranchReportExport], {
        authToken,
        productId: productId !== 0 ? productId : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType.split(' ').join('')) : undefined,
        fundType: fundType ? UtilFunctions.Misc.getEnumValueByKey(FundTypeEnum, fundType.split(' ').join('')) : undefined,
        serialNo: serialNo ? serialNo : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.reportGetInventoryBranchReportExportFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.reportGetInventoryBranchReportExportSuccess(response.data));
    }
}
